var CreateEntityBaseDismissReason = /* @__PURE__ */ ((CreateEntityBaseDismissReason2) => {
  CreateEntityBaseDismissReason2["Cancel"] = "cancel";
  CreateEntityBaseDismissReason2["Success"] = "success";
  CreateEntityBaseDismissReason2["CallerProp"] = "callerprop";
  return CreateEntityBaseDismissReason2;
})(CreateEntityBaseDismissReason || {});
export {
  CreateEntityBaseDismissReason
};
//# sourceMappingURL=CreateEntityBase.types.js.map
